/**
 * Delay (in milliseconds) added to account for Auth0's low latency
 * when creating, blocking, or unblocking users. This ensures we allow
 * enough time before refetching user data to receive consistent results.
 *
 * Increasing this value can help prevent stale data fetches after
 * user-related operations.
 *
 * @constant {number}
 * @readonly
 */
export const AUTH0_LATENCY_DELAY = 1000;
